<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import {
		handleSubmit,
		shuffle,
		parseFormdata,
		updateNextRoute,
	} from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required, Hint } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();
	const requireInput = true;

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	const mustBeInteger = (x) => {
		if (isNaN(Number(x))) {
			console.log("not a number");
			return { mustBeInteger: true };
		}
	};

	let fields = [
		{
			labelName: "crt_mark-adam-28",
			label: "The ages of Mark and Adam add up to 28 years total. Mark is 20 years older than Adam. How many years old is Adam?",
			options: [
				{
					// type: "number",
					value: "", // value/response to send to server
					option: "", // what to display
				},
			],
			validators: [mustBeInteger],
			hintText: "Enter just a number",
		},
		{
			labelName: "crt_10-50-printer",
			label: "If it takes 10 seconds for 10 printers to print out 10 pages of paper, how many seconds will it take 50 printers to print out 50 pages of paper?",
			options: [
				{
					// type: "number",
					value: "", // value/response to send to server
					option: "", // what to display
				},
			],
			validators: [mustBeInteger],
			hintText: "Enter just a number",
		},
		{
			labelName: "crt_mold-bread-40",
			label: "On a loaf of bread, there is a patch of mold. Every day, the patch doubles in size. If it takes 40 days for the patch to cover the entire loaf of bread, how many days would it take for the patch to cover half of the loaf of bread?",
			options: [
				{
					// type: "number",
					value: "", // value/response to send to server
					option: "", // what to display
				},
			],
			validators: [mustBeInteger],
			hintText: "Enter just a number",
		},
		{
			labelName: "crt_pass-second-place",
			label: "If you're running a race and you pass the person in second place, what place are you in?",
			options: [
				{
					// type: "number",
					value: "", // value/response to send to server
					option: "", // what to display
				},
			],
			validators: [mustBeInteger],
			hintText: "Enter a number instead of text",
		},
		{
			labelName: "crt_sheep-15-8-died",
			label: "A farmer had 15 sheep and all but 8 died. How many are left?",
			options: [
				{
					// type: "number",
					value: "", // value/response to send to server
					option: "", // what to display
				},
			],
			validators: [mustBeInteger],
			hintText: "Enter just a number",
		},
		{
			labelName: "crt_emily-april-may",
			label: "Emily's father has three daughters. The first two are named April and May. What is the third daughter's name?",
			options: [
				{
					type: "text",
					value: "", // value/response to send to server
					option: "", // what to display
				},
			],
			validators: [],
			hintText: "",
		},
	];

	// fields = fields.slice(fields.length - 2, fields.length);
	fields = shuffle(fields);

	if (requireInput) {
		fields.forEach((f, fi) => {
			fields[fi].validators.push(required);
		});
	}
</script>

<Navbar />

<section>
	<h1>Word problems</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={field.validators}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
				<Hint for={field.labelName} on="mustBeInteger">
					<span style="color:red">{field.hintText}</span>
				</Hint>
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}
	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 8px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1150px) {
		.option-group {
			display: block;
		}
	}
</style>
